import { Box, Heading, List, ListItem, VisuallyHidden } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { ContentContainer } from '~/components/container';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';
import { Markdown } from '~/components/markdown';

export type HowDoesItWorkSectionProps = {
  title: string;
  steps: Array<{ _id: string; title: string; text: string }>;
};

export function HowDoesItWorkSection({ title, steps = [] }: HowDoesItWorkSectionProps) {
  return (
    <Box as='section'>
      <ContentContainer>
        <Heading as='h3' marginBottom='24px' size='marketing-3xl'>
          {title}
        </Heading>
        <List
          as='ol'
          display='flex'
          flexWrap='wrap'
          gap={{
            base: '16px',
            md: '32px',
          }}
        >
          {/* Note: card layout changes depending on number of steps.
            See Design: https://www.figma.com/file/cRWhIC0ROTnJtFF2LVyltb/All-Access-Static-Pages?node-id=499%3A2218&mode=dev
            2 cards: 1x2
            3 cards: 1x3
            4 cards: 2x2 <== Special Case!
            5 cards: 1x3, 1x2
            6 cards: 1x3, 1x3 */}
          {steps.map((step, idx) => (
            <ListItem key={step._id} display='flex' flex={steps.length === 4 ? '1 1 354px' : '1 1 352px'}>
              <Card
                as='article'
                backgroundColor='blue.800'
                border='none'
                borderRadius='md'
                color='white'
                padding='40px 32px'
                width='100%'
              >
                <Heading as='p' color='accent.lime' size='marketing-5xl'>
                  <VisuallyHidden>Step </VisuallyHidden>
                  {idx + 1}
                </Heading>
                <HeadingWithEmphasis
                  text={step.title}
                  emphasisProps={{
                    fontWeight: '500',
                  }}
                  headingProps={{
                    as: 'p',
                    size: 'h3',
                    marginBottom: '24px',
                  }}
                />
                <Box
                  sx={{
                    a: {
                      color: 'accent.sea-foam.500 !important',
                    },
                  }}
                >
                  <Markdown markdownText={step.text} />
                </Box>
              </Card>
            </ListItem>
          ))}
        </List>
      </ContentContainer>
    </Box>
  );
}
